// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__JoUkz","col":"styles_col__36jkW"};